import axios, { AxiosInstance } from 'axios'
import { createContext } from 'react'

export const WebapiClientContext = createContext<AxiosInstance>(axios.create())

export const WebapiClientContextProvider = WebapiClientContext.Provider
export const WebapiClientContextConsumer = WebapiClientContext.Consumer
